import { Component, forwardRef, Injector, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig, RenderComponentBase } from '../../../dynamic-component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-r-radio',
  templateUrl: './r-radio.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RRadioComponent),
      multi: true
    }
  ]
})
export class RRadioComponent extends RenderComponentBase {
  static KEY = 'r-d-radio';

  constructor(injector: Injector) {
    super(injector);
  }

  configChange(config: IDynamicComponentConfig) {
    if (!Array.isArray(config.dataSource)) {
      config.dataSource = [
        {
          value: '1',
          label: '选项1'
        },
        {
          value: '2',
          label: '选项2'
        },
        {
          value: '3',
          label: '选项3'
        }
      ];
    }
  }
}
